<template>
  <div class="bg-white p-4" id="quoteGen">
    <div class="flex items-center py-4 w-full px-0 font-semibold">
     <button class="flex items-center whitespace-nowrap">
        <img
        src="@/assets/images/icons/back-icon.svg"
        @click="$router.go(-1)"
        class="mr-4 cursor-pointer"
      />Booking Invoice
     </button>
     <div class="w-full flex justify-end">
        <img
        src="@/assets/images/icons/Group 11414.svg"
        @click="$router.go(-1)"
        class="mr-4 cursor-pointer"
      />
     </div>
    </div>

    <div class="title-container">
      <span class="w-full block py-2"
        >Shipping ID #:
        {{
          transaction.shipping.shippingReference
            ? transaction.shipping.shippingReference
            : "N/A"
        }}</span
      >
      <span class="w-full block py-2 break-words"
        >Shipping Status:
        {{ transaction.shipping.deliveryStatus || "N/A" }}</span
      >
      <span class="w-full block py-2"
        >Transaction Date:
        {{ (transaction.createdAt || "").split("T")[0] || "N/A" }}</span
      >
      <span class="w-full block py-2"
        >Payment Status: {{ transaction ? transaction.status : "null" }}</span
      >
    </div>

    <div
      class="flex items-center text-2xl justify-between py-4 text-right px-2"
    >
      Total Shipping Cost: {{ transaction.totalValue - 0 }}
    </div>

    <div class="flex flex-wrap py-3 justify-between">
      <div class="detail-container py-3 px-3">
        <b class="py-2 inline-block">Shipment Info</b>
        <ul class="detail-list">
          <li class="flex items-center justify-between">
            <span>No of Items: </span>
            <span>{{ transaction.shipping.packagees.length || "0" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Transaction Channel: </span>
            <span>{{ transaction.payment_type || "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Mode of Shipment: </span>
            <span>{{
              transaction.shipping.shippingservice
                ? transaction.shipping.shippingservice.shippingMethod
                : "N/A"
            }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Service: </span>
            <span>{{
              transaction.shipping.shippingservice
                ? transaction.shipping.shippingservice.orgName
                : "N/A"
            }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Gross Weight: </span>
            <span>{{ totalWeight || 0 }} (KG)</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Total Shipment Cost: </span>
            <span class="font-bold"
              >&#8358; {{ transaction.totalValue - 0 }}</span
            >
          </li>
        </ul>
      </div>

      <div class="detail-container py-3 px-3">
        <b class="py-2 inline-block">Reciever Info</b>
        <ul class="detail-list">
          <li class="flex items-center justify-between">
            <span>Name: </span>
            <span>{{ reciever.contactName || "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>MuleEx ID: </span>
            <span>{{ "******" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Address: </span>
            <span>{{ reciever.address ? reciever.address.name : "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Email: </span>
            <span>{{ reciever.email || "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Phone No: </span>
            <span>{{ reciever.mobile || 'N/A' }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Est. Delivery Date: </span>
            <span class="font-bold"> {{ "N/A" }}</span>
          </li>
        </ul>
      </div>

      <div class="detail-container py-3 px-3">
        <b class="py-2 inline-block">Sender Info</b>
        <ul class="detail-list">
          <li class="flex items-center justify-between">
            <span>Name</span>
            <span>{{ sender.contactName ? sender.contactName : "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>MuleEx ID: </span>
            <span>{{ "******" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Address: </span>
            <span>{{ sender.address ? sender.address.name : "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Email: </span>
            <span>{{ sender.email ? sender.email : "N/A" }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Phone No: </span>
            <span>{{ sender.mobile  ? sender.mobile : 0 }}</span>
          </li>
          <li class="flex items-center justify-between">
            <span>Est. Delivery Date: </span>
            <span class="font-bold"> {{ "N/A" }}</span>
          </li>
        </ul>
      </div>

    </div>



    <div class="text-left py-5 overflow-x-auto">
      <table width="100%">
        <thead>
          <tr>
            <th>Shipping Reference</th>
            <th>Item Description</th>
            <th>Packaging</th>
            <th>Quantity</th>
            <th>Total Weight (KG)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in transaction.shipping.packagees" :key="item">
            <td>Shipping Reference</td>
            <td>{{ item.description ? item.description : "N/A" }}</td>
            <td>{{ item.packageType ? item.packageType : "N/A" }}</td>
            <td>{{ item.quantity ? item.quantity : "N/A" }}</td>
            <td>
              {{ item.estimatedWeight ? item.estimatedWeight : "N/A" }} ({{ item.unitOfWeight ? item.unitOfWeight : '' }})
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-gray-100 py-3 flex px-3  items-center">
      <div class="w-6/12"></div>

      <div class="w-3/12 text-center">
        <ul class="text-right ship-content">
          <li>Gross Weight:</li>
          <li>Net Shipment Cost:</li>
          <li>Discount:</li>
        </ul>
        <b class="w-full text-right block pt-2">Total Shipping Cost:</b>
      </div>

      <div class="w-3/12 text-right">
        <ul class="text-right ship-content">
          <li>{{ totalWeight }} (KG)</li>
          <li>&#8358; {{ transaction.totalValue }}</li>
          <li>&#8358; 0</li>
        </ul>
        <b class="w-full text-right block pt-2">
          &#8358; {{ transaction.totalValue - 0 }}</b
        >
      </div>
    </div>


    <div class="flex justify-end">
        <button 
        @click="generateQuote"
        class="rounded-md mt-6 py-2 px-3 flex items-center bg-primary-yellow">
            <span class="block mr-2">
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 6H12V0H7.99998V6H4.99998L9.99998 11L15 6ZM19.338 12.532C19.128 12.308 17.727 10.809 17.327 10.418C17.0467 10.1493 16.6733 9.99951 16.285 10H14.528L17.592 12.994H14.048C13.9998 12.9931 13.9523 13.0049 13.9101 13.0283C13.868 13.0516 13.8328 13.0857 13.808 13.127L12.992 15H7.00798L6.19198 13.127C6.16705 13.0858 6.13178 13.0519 6.08968 13.0286C6.04758 13.0052 6.00011 12.9933 5.95198 12.994H2.40798L5.47098 10H3.71498C3.31798 10 2.93898 10.159 2.67298 10.418C2.27298 10.81 0.871981 12.309 0.661981 12.532C0.172981 13.053 -0.0960191 13.468 0.0319809 13.981L0.592981 17.055C0.720981 17.569 1.28398 17.991 1.84498 17.991H18.157C18.718 17.991 19.281 17.569 19.409 17.055L19.97 13.981C20.096 13.468 19.828 13.053 19.338 12.532Z"
                  fill="#383F51"
                />
              </svg>
            </span>
            <span class="text-sm block"> Download Invoice</span>
          </button>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  data() {
    return {
      transactionId: this.$route.params.id,
      transaction: {},
    };
  },
  mounted() {
    this.getReciept();
  },
  computed: {
    reciever() {
      return this.transaction?.shipping?.consigneelocation || {};
    },
    sender() {
      return this.transaction?.shipping?.shipperlocation || {};
    },
    transactionHeader() {
      let header = "";
      switch (this.type) {
        case "quote":
          header = " Estimates";
          break;
        case "recievable":
          header = " Receivables";
          break;
        default:
          header = "  Collections (Shipment Receipt)";
          break;
      }
      return header;
    },
    type() {
      return localStorage.getItem("billing_reciept");
    },
    discription() {
      if (!this.transaction?.shipping?.packagees.length) return "";
      return this.transaction?.shipping?.packagees
        .map((item) => (item?.description ? item?.description + ", " : ""))
        .reduce((prev, next) => prev + next);
    },
    totalWeight() {
      if (!this.transaction?.shipping?.packagees.length) return 0;
      return this.transaction.shipping.packagees
        .map((item) => item.estimatedWeight)
        .reduce((prev, next) => prev + next);
    },
  },
  methods: {
    generateQuote() {
      try {
        var element = document.getElementById("quoteGen");
        html2pdf(element);
      } catch (e) {
        // ...any code here
      }
    },
    async getReciept() {
      try {
        let response = await this.$_getReciept(this.transactionId);
        this.transaction = response.data.data.transaction;
        console.log(">>>>>>>>>>>>>>>>>>",  this.transaction)
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  @apply flex bg-primary-yellow py-4 px-3 flex-wrap rounded-md ;

}
.ship-content {
  li {
    @apply pt-2;
  }
}
.detail-container {
  @apply bg-gray-100 rounded-md;
  width: 31.5%;
}
.detail-list {
  li {
    @apply py-2 opacity-50;
  }
}
td {
  @apply pl-0;
}
th {
  @apply pb-2;
}
tr {
  @apply border-gray-200;
  border-bottom-width: 2px;
}
</style>
